export default __webpack_public_path__ + "static/media/miniportrait.cdbf4f5d.gif";